webpackJsonp([1],{

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fbbf522",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(177);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("8303dd5e", content, true);

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".row[data-v-6fbbf522]{width:100%;height:1.28rem;background-color:#fff;border-bottom:1px solid #e6ecf2}.row.checked .left .checkbox[data-v-6fbbf522]{border-color:#e78081}.row.checked .left .checkbox[data-v-6fbbf522]:before{border-color:transparent transparent #e78081 #e78081}.left[data-v-6fbbf522]{padding-left:.26667rem}.left .checkbox[data-v-6fbbf522]{position:relative;display:inline-block;width:.42667rem;height:.42667rem;line-height:.42667rem;margin-right:.26667rem;font-size:12px;text-align:center;border:1px solid #98a4b3;border-radius:50%}.left .checkbox[data-v-6fbbf522]:before{position:absolute;content:\"\";left:.05333rem;top:.10667rem;width:.26667rem;height:.13333rem;border:1px solid transparent;-webkit-transform:rotate3D(0,0,1,-45deg);transform:rotate3D(0,0,1,-45deg)}.left .editing-name[data-v-6fbbf522]{border:none;width:100%;color:#e78081}.btn-list .gift[data-v-6fbbf522]{display:inline-block;height:1.28rem;line-height:1.28rem;padding:0 .32rem}.btn-list .gift[data-v-6fbbf522]:active{background-color:#e78081;color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/components/ListManage.vue"],"names":[],"mappings":"AACA,sBACE,WAAY,AACZ,eAAgB,AAChB,sBAAuB,AACvB,+BAAiC,CAClC,AACD,8CACE,oBAAsB,CACvB,AACD,qDACE,oDAAsD,CACvD,AACD,uBACE,sBAAyB,CAC1B,AACD,iCACE,kBAAmB,AACnB,qBAAsB,AACtB,gBAAkB,AAClB,iBAAmB,AACnB,sBAAwB,AACxB,uBAAyB,AACzB,eAAgB,AAChB,kBAAmB,AACnB,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,wCACE,kBAAmB,AACnB,WAAY,AACZ,eAAiB,AACjB,cAAgB,AAChB,gBAAkB,AAClB,iBAAmB,AAEnB,6BAA0B,AAE1B,yCAA6C,AACrC,gCAAqC,CAC9C,AACD,qCACE,YAAa,AACb,WAAY,AACZ,aAAe,CAChB,AACD,iCACE,qBAAsB,AACtB,eAAgB,AAChB,oBAAqB,AACrB,gBAAmB,CACpB,AACD,wCACE,yBAA0B,AAC1B,UAAY,CACb","file":"ListManage.vue","sourcesContent":["\n.row[data-v-6fbbf522] {\n  width: 100%;\n  height: 1.28rem;\n  background-color: #fff;\n  border-bottom: 1px solid #e6ecf2;\n}\n.row.checked .left .checkbox[data-v-6fbbf522] {\n  border-color: #e78081;\n}\n.row.checked .left .checkbox[data-v-6fbbf522]::before {\n  border-color: transparent transparent #e78081 #e78081;\n}\n.left[data-v-6fbbf522] {\n  padding-left: 0.26667rem;\n}\n.left .checkbox[data-v-6fbbf522] {\n  position: relative;\n  display: inline-block;\n  width: 0.42667rem;\n  height: 0.42667rem;\n  line-height: 0.42667rem;\n  margin-right: 0.26667rem;\n  font-size: 12px;\n  text-align: center;\n  border: 1px solid #98a4b3;\n  border-radius: 50%;\n}\n.left .checkbox[data-v-6fbbf522]::before {\n  position: absolute;\n  content: '';\n  left: 0.05333rem;\n  top: 0.10667rem;\n  width: 0.26667rem;\n  height: 0.13333rem;\n  border-style: solid;\n  border-color: transparent;\n  border-width: 1px;\n  -webkit-transform: rotate3D(0, 0, 1, -45deg);\n          transform: rotate3D(0, 0, 1, -45deg);\n}\n.left .editing-name[data-v-6fbbf522] {\n  border: none;\n  width: 100%;\n  color: #e78081;\n}\n.btn-list .gift[data-v-6fbbf522] {\n  display: inline-block;\n  height: 1.28rem;\n  line-height: 1.28rem;\n  padding: 0 0.32rem;\n}\n.btn-list .gift[data-v-6fbbf522]:active {\n  background-color: #e78081;\n  color: #fff;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: String,
    data: {
      type: Array,
      validator: function validator(val) {
        return val.every(function (v) {
          return v.id != null;
        });
      }
    },
    max: Number,
    duplicatable: {
      type: Boolean,
      default: false
    },
    localeSort: {
      type: Boolean,
      default: true
    },
    selection: Number
  },
  data: function data() {
    return {
      editingIndex: -1,
      oldName: '',
      newName: '',
      isAdding: false,
      isMultiRemoving: false,
      checkedList: []
    };
  },

  computed: {
    sortedList: function sortedList() {
      if (this.localeSort) {
        return this.data.slice().sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }
      return data;
    },
    editingMode: function editingMode() {
      return this.editingIndex > -1 || this.isMultiRemoving || this.isAdding;
    }
  },
  methods: {
    focus: function focus() {
      var _this = this;

      this.$nextTick(function () {
        setTimeout(function () {
          if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* isArray */])(_this.$refs.input)) {
            _this.$refs.input[0].focus();
          } else {
            _this.$refs.input.focus();
          }
        }, 300);
      });
    },
    toggleChecked: function toggleChecked(index) {
      var _index = this.checkedList.indexOf(index);
      if (_index > -1) {
        this.checkedList.splice(_index, 1);
      } else {
        if (this.selection === 1) {
          this.checkedList = [index];
        } else {
          this.checkedList.push(index);
        }
      }
    },
    add: function add() {
      if (this.max && this.data.length >= this.max) {
        this.$toast('\u6700\u591A\u53EA\u80FD\u6DFB\u52A0' + this.max + '\u6761\u8BB0\u5F55');
        return;
      }
      this.newName = '';
      this.isAdding = true;
      this.focus();
    },
    cancel: function cancel() {
      this.editingIndex = -1;
      this.isAdding = false;
      this.isMultiRemoving = false;
      this.checkedList = [];
    },
    edit: function edit(item, index) {
      this.oldName = item.name;
      this.newName = item.name;
      this.editingIndex = index;
      this.focus();
    },
    remove: function remove(item, index) {
      this.$emit('remove', index);
    },
    save: function save() {
      var _this2 = this;

      var name = this.newName.trim();
      if (!this.duplicatable && this.data.some(function (item, index) {
        return _this2.editingIndex !== index && item.name === name;
      })) {
        return this.$toast('已存在相同项');
      }
      if (this.isAdding) {
        this.$emit('add', name);
        this.cancel();
      } else if (this.isMultiRemoving) {
        this.$confirm('\u786E\u8BA4\u8981\u5220\u9664\u6240\u9009\u7684' + this.checkedList.length + '\u9879\u4E48\uFF1F').then(function () {
          _this2.$emit('remove', _this2.checkedList.slice());
          _this2.cancel();
        });
      } else if (this.selection) {
        this.$emit('select', this.checkedList.map(function (index) {
          return _this2.sortedList[index];
        }));
      } else {
        if (!name) {
          return;
        }

        if (this.oldName !== name) {
          this.$emit('update', this.editingIndex, name);
        }
        this.cancel();
      }
    },
    multiRemove: function multiRemove() {
      this.editingIndex = -1;
      this.isMultiRemoving = true;
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": !_vm.editingMode,
      "prevent-back": !!_vm.selection
    },
    on: {
      "back": function($event) {
        _vm.$emit('back')
      }
    }
  }, [(_vm.editingMode) ? _c('span', {
    staticClass: "gift icon-cross",
    attrs: {
      "slot": "left"
    },
    on: {
      "click": _vm.cancel
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.selection) ? _c('span', {
    on: {
      "click": _vm.add
    }
  }, [_c('span', {
    staticClass: "gift icon-plus"
  }, [_vm._v(" 添加" + _vm._s(_vm.title))])]) : _c('span', [_vm._v(_vm._s(_vm.isMultiRemoving ? '批量删除' : _vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-1 flex-between",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [(!_vm.selection && !_vm.editingMode && _vm.data.length) ? _c('span', {
    staticClass: "gift icon-multi",
    on: {
      "click": _vm.multiRemove
    }
  }) : _c('span', [_vm._v(" ")]), _vm._v(" "), (_vm.selection || _vm.editingMode) ? _c('span', {
    staticClass: "gift icon-zhengque",
    on: {
      "click": _vm.save
    }
  }) : _c('span', {
    staticClass: "gift icon-plus",
    on: {
      "click": _vm.add
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "scrollable flex-1"
  }, [(!_vm.data.length && !_vm.isAdding) ? _vm._t("default") : _vm._e(), _vm._v(" "), (_vm.isAdding) ? _c('div', {
    staticClass: "row flex flex-column checked"
  }, [_c('div', {
    staticClass: "left flex flex-1 flex-cross-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newName),
      expression: "newName"
    }],
    ref: "input",
    staticClass: "editing-name",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newName = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "longpress",
        rawName: "v-longpress",
        value: (function () {
          _vm.multiRemove();
          _vm.checkedList = [index]
        }),
        expression: "()=>{multiRemove();checkedList=[index]}"
      }],
      key: item.id,
      staticClass: "row flex flex-cross-center flex-between",
      class: {
        checked: _vm.checkedList.indexOf(index) > -1
      },
      on: {
        "click": function($event) {
          _vm.toggleChecked(index)
        }
      }
    }, [_c('div', {
      staticClass: "left flex-inline flex-cross-center"
    }, [(_vm.isMultiRemoving || _vm.selection) ? _c('span', {
      staticClass: "checkbox"
    }) : _vm._e(), _vm._v(" "), (_vm.editingIndex === index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newName),
        expression: "newName"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "editing-name",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.newName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newName = $event.target.value
        }
      }
    }) : _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (!_vm.isMultiRemoving && (_vm.editingIndex === -1 || index !== _vm.editingIndex)) ? _c('div', {
      staticClass: "btn-list flex-inline flex-cross-center"
    }, [_c('span', {
      staticClass: "gift icon-edit",
      on: {
        "click": function($event) {
          _vm.edit(item, index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "gift icon-lajixiang",
      on: {
        "click": function($event) {
          _vm.remove(item, index)
        }
      }
    })]) : _vm._e()])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ListManage__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ListManage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ListManage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(6);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selection: Number
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['tags'])),
  components: {
    ListManage: __WEBPACK_IMPORTED_MODULE_2__components_ListManage___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['addTag', 'updateTag', 'removeTag', 'removeTags']), {
    add: function add(name) {
      this.addTag(name);
    },
    update: function update(index, name) {
      this.updateTag({ index: index, name: name });
    },
    remove: function remove(index) {
      if (Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* isArray */])(index)) {
        this.removeTags(index);
      } else {
        this.removeTag(index);
      }
    }
  })
});

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-manage', {
    attrs: {
      "title": "分类",
      "max": 100,
      "prevent-back": !!_vm.selection,
      "selection": _vm.selection,
      "data": _vm.tags
    },
    on: {
      "back": function($event) {
        _vm.$emit('back')
      },
      "add": _vm.add,
      "update": _vm.update,
      "remove": _vm.remove,
      "select": function (args) { return _vm.$emit('select', args); }
    }
  }, [_c('p', {
    staticClass: "t-c",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("暂时还没有分类哦，请先添加一个吧")])])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.dd0c47adc9c1957b209f.js